import React from 'react'
import PropTypes from 'prop-types'

const TabBar = (props) => {
  const { children } = props
  return (
    <div className="tabbar">
      { children }
    </div>
  )
}

TabBar.propTypes = { children: PropTypes.node.isRequired }

export default TabBar
